export default {
  title: 'Trilha de Auditoria',
  exportCsv: 'Exportar CSV',
  refresh: 'Atualizar',
  startDateLabel: 'Data de Início',
  endDateLabel: 'Data de Fim',
  actionTypeLabel: 'Tipo de Ação',
  targetUserEmailLabel: 'Email do Usuário Alvo',
  viewChanges: 'Ver Alterações',
  changeDetailsTitle: 'Detalhes da Alteração',
  actionLabel: 'Ação:',
  performedByLabel: 'Realizado Por:',
  targetUserLabel: 'Usuário Alvo:',
  modelIdLabel: 'ID do Modelo:',
  timestampLabel: 'Data e Hora:',
  changesTitle: 'Alterações',
  beforeLabel: 'Antes:',
  afterLabel: 'Depois:',
  headerTimestamp: 'Data e Hora',
  headerAction: 'Ação',
  headerPerformedBy: 'Realizado Por',
  headerTargetUser: 'Usuário Alvo',
  headerModelId: 'ID do Modelo',
  headerChanges: 'Alterações',
  actionGrantAccess: 'Conceder Acesso',
  actionRevokeAccess: 'Revogar Acesso',
  actionGrantReferenceAccess: 'Conceder Acesso de Referência',
  actionRevokeReferenceAccess: 'Revogar Acesso de Referência',
  actionGrantEkrmAccess: 'Conceder Acesso EKRM',
  actionRevokeEkrmAccess: 'Revogar Acesso EKRM',
  actionDeleteUser: 'Excluir Usuário',
  actionGrantGroupAccess: 'Conceder Acesso a Grupo',
  actionRevokeGroupAccess: 'Revogar Acesso a Grupo',
  actionCreateGroup: 'Criar Grupo',
  actionDeleteGroup: 'Excluir Grupo',
  actionGrantGroupModelAccess: 'Conceder Acesso de Modelo a Grupo',
  actionRevokeGroupModelAccess: 'Revogar Acesso de Modelo a Grupo',
  actionGrantGroupReferenceAccess: 'Conceder Acesso de Referência a Grupo',
  actionRevokeGroupReferenceAccess: 'Revogar Acesso de Referência a Grupo',
  actionGrantGroupEkrmAccess: 'Conceder Acesso EKRM a Grupo',
  actionRevokeGroupEkrmAccess: 'Revogar Acesso EKRM a Grupo',
  actionUnknown: 'Ação Desconhecida',
  timestampNA: 'N/D',
  timestampInvalid: 'Data Inválida',
  exportSuccess: 'Registros de auditoria exportados com sucesso',
  exportError: 'Erro ao exportar registros de auditoria: ',
  loadError: 'Erro ao carregar registros de auditoria: ',
  indexErrorHint: ' Tente remover alguns filtros para reduzir a complexidade da consulta.'
}
